import useSWR from 'swr'

export const useFetchPage = (key, fetcher) => {
  const { data, error } = useSWR(`${key}`, fetcher)
  return {
    data: data?.data?.attributes,
    isLoading: !error && !data,
    isError: error
  }
}
